
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import withNavigateHook from '../../myRoutes';
import React, { Component } from "react";
import banner from '../pics/banner.PNG';
import Select from 'react-select';
import { FaWhatsapp, FaSearch } from 'react-icons/fa';
import { ArrowLeft } from 'react-bootstrap-icons';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getAllCustomerOrders, getOrderStatuses, getAllOrderStatuses, formatDate } from '../Utils/Utils';
import { Ordertable } from '../Ordertable/Ordertable';
import { LoadingPage } from '../Loadingpage/Loadingpage';
import { LayoutDashboard, Menu, User, Power, Plus, Shirt, Layers, Sparkles, Truck, CircleDollarSign, ChevronRight } from 'lucide-react';
import axios from 'axios';
import {
    useReactTable,
    getCoreRowModel,
    getPaginationRowModel,
    flexRender,
} from '@tanstack/react-table'

class Uat extends React.Component {
    constructor(props) {
        super(props);
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            servicedate: new Date(),
            mycomments: '',
            loadweights: '',
            mobilePhone: '',
            address: '',
            totalamount: '0.00',
            shouldRedirect: false,
            fullname: "",
            emailaddress: "",
            phonenumber: "",
            token: "",
            role: "",
            address: "",
            city: "",
            area: "",
            userid: "11",
            allCustomerOrders: [],
            allorderstatuses: [],
            orderCount: 0,
            page: 'allOrders',
            lastorderstatus: '',
            pricelists: [],
            foldlist: [],
            prices: [],
            searchTerm: '',
            isLoading: true

        }
    }
    orderstats = []
    strStat = ''
    foldlist = []
    services = [
        {
            id: 'iron-fold',
            title: 'IRON & FOLD',
            description: 'Neatly ironed and folded garments.',
            icon: <Shirt className="w-8 h-8 text-teal-600" />,
            bg: 'bg-white',
        },
        {
            id: 'wash-dry-fold',
            title: 'WASH, DRY & FOLD',
            description: 'Neatly washed and folded garments.',
            icon: <Layers className="w-8 h-8 text-teal-600" />,
            bg: 'bg-white',
        },
        {
            id: 'premium-service',
            title: 'PREMIUM FULL SERVICE',
            subtitle: '(WASH-DRY-IRON-FOLD)',
            description: 'Neatly dry, iron, folded garments.',
            icon: <Sparkles className="w-8 h-8 text-teal-600" />,
            bg: 'bg-white',
        },
        {
            id: 'track-order',
            title: 'TRACK YOUR ORDER',
            description: 'Live status and delivery estimate.',
            icon: <Truck className="w-8 h-8 text-white" />,
            bg: 'bg-slate-500 text-white',
            isAction: true,
        },
        {
            id: 'pricelist',
            title: 'OUR PRICELIST',
            description: 'Explore rates',
            icon: <CircleDollarSign className="w-8 h-8 text-teal-600" />,
            bg: 'bg-white',
            isLink: true,
        }
    ];


    getPriceList = async () => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "iwash_laundry", "pricelist": "washdryfold" }
        }
        // const url = "http://localhost/iwash-php/api/UAT_getPriceList.php";
        const url = "https://testmembership.bktsystems.com/api/UAT_getPriceList.php";
        const response = await axios.get(url, config);

        const wasdryfoldlist = response.data.weightlist;
        const wasdryfoldprice = response.data.washdryfoldprice;

        try {
            // 2. Convert the text string into a real JavaScript array
            const parsedwasdryfoldlist = new Function(`return ${wasdryfoldlist};`)();

            // 3. Save the actual array to your state
            this.setState({ foldlist: parsedwasdryfoldlist, prices: response.data.washdryfoldprice });
        } catch (error) {
            console.error("Failed to parse JSON string:", error);
            this.setState({ foldlist: [], prices: [] }); // Fallback to empty array if parsing fails
        }
        // console.log("Pricelist details response: " + wasdryfoldprice);
        return response.data;
    }

    componentDidMount = async () => {
        let strOrders = await getAllCustomerOrders("11");
        //  console.log("All orders: ", strOrders);
        this.setState({ isLoading: false });
        // if (localStorage.getItem("token") === null || localStorage.getItem("token") === undefined || localStorage.getItem("token") === "") {
        //   this.setState({ shouldRedirect: true });
        //}
        // else {
        this.setState({
            fullname: 'Jean Bruno', emailaddress: 'king.jeanbruno@gmail.com',
            phonenumber: '0722903449', role: 'Admin', address: '123 Main Street', area: 'Downtown', city: 'Nairobi',
            userid: "11", allCustomerOrders: await getAllCustomerOrders("11"), allorderstatuses: await getAllOrderStatuses(), pricelists: await this.getPriceList()
        })

        if (strOrders.includes('no data')) {
            this.setState({ orderCount: 0 });
        }
        else {
            this.setState({ orderCount: strOrders.length });
        }

        //  console.log(strOrders);
        //  this.ws.onclose = () => console.log('Disconnected');
    }

    getLastOrderStatus = (orderid) => {
        let lastStatus = 'Submitted'
        if ((this.state.allorderstatuses.length !== 0) && (Array.isArray(this.state.allorderstatuses))) {
            for (let i = 0; i < this.state.allorderstatuses.length; i++) {
                if (this.state.allorderstatuses[i].orderid === orderid) {
                    lastStatus = this.state.allorderstatuses[i].status
                    break
                }
            }
            //  console.log(this.state.allorderstatuses)                        
        }
        return lastStatus
    }
    setClothingWeightsChange = (currentWeight) => {
        const prices = JSON.parse(this.state.prices);
        const currentPrice = prices[currentWeight];
        console.log('Current weight selected: ' + currentPrice);

    };

    goBackToMenu = (e) => {
        e.preventDefault();
        this.props.navigate('/menu', {
            state: {
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress,
                phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role, address:
                    this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city, userid: this.props.location.state.userid
            }
        });
    }
    ///////////////////////////////////////////
    setSearchTerm = (e) => {

        if (e.target.value.trimEnd() === '' || e.target.value.trimStart() === '') {
            this.componentDidMount();
            return;
        }
        // const searchResult = this.state.allCustomerOrders.filter(order => {
        //     return order.id.includes(e.target.value.trimStart()) || order.fullname.toLowerCase().includes(e.target.value.toLowerCase());
        // });
        const searchResult = this.state.allCustomerOrders.filter(order => {
            return ((order.modified).slice(0, 10)).includes(e.target.value)
        });
        // searchResult.sort((a, b) => new Date(b.servicedate) - new Date(a.servicedate));    
        this.setState({ searchTerm: e.target.value, allCustomerOrders: searchResult });
    }

    clearSearchTerm = (e) => {
        if (e.key === 'Backspace' && this.state.searchTerm.length === 1) {
            this.setState({ searchTerm: '' });
            this.componentDidMount();
        }
    }

    ////////////////////////////////////////////////////

    ////////////////////////////////////////////

    render() {
        if (this.state.isLoading) {
            return <LoadingPage />;
        }
        return (

            <div className="max-w-md mx-auto bg-slate-50 min-h-screen shadow-xl flex flex-col justify-between font-sans overflow-hidden relative pb-6">
                {/* Decorative background water droplets patterns */}
                <div className="absolute bottom-4 left-4 text-teal-200 opacity-40 pointer-events-none select-none text-xl">💧💧💧</div>
                <div className="absolute bottom-4 right-4 text-teal-200 opacity-40 pointer-events-none select-none text-xl">🧵</div>

                <div>
                    {/* Banner Image Area */}
                    <div className="relative h-44 bg-slate-800 overflow-hidden">
                        <img
                            src="https://images.unsplash.com/photo-1545173168-9f19472ef7f4?auto=format&fit=crop&w=600&q=80"
                            alt="Laundromat washing machines"
                            className="w-full h-full object-cover opacity-80"
                        />
                        {/* Frosted Glass Header Overlay */}
                        <div className="absolute bottom-0 inset-x-0 bg-white/30 backdrop-blur-md py-3 px-4 flex justify-between items-center border-t border-white/20">
                            <button className="text-teal-800 p-1 hover:bg-white/20 rounded-lg transition">
                                <Menu className="w-6 h-6" />
                            </button>
                            <span className="text-slate-800 font-semibold tracking-wide text-sm sm:text-base">
                                {/* {currentDate} */}
                            </span>
                            <div className="flex items-center gap-3">
                                <div className="relative w-9 h-9 bg-amber-100 rounded-full flex items-center justify-center border-2 border-amber-400 text-amber-700 font-bold text-xs shadow-sm">
                                    DM
                                    <span className="absolute -top-1.5 -right-1 text-[10px]">👑</span>
                                </div>
                                <button className="text-teal-900 hover:text-red-600 transition">
                                    <Power className="w-5 h-5" />
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Service Cards List */}
                    <div className="p-4 space-y-4">
                        {this.services.map((service) => {
                            const isDarkBg = service.isAction;
                            return (
                                <div
                                    key={service.id}
                                    className={`${service.bg} rounded-2xl p-4 flex items-center justify-between shadow-sm border border-slate-100 hover:shadow-md transition-all duration-200 cursor-pointer group`}
                                >
                                    <div className="flex items-center gap-4">
                                        {/* Left Icon Wrapper */}
                                        <div className={`p-2.5 rounded-xl ${isDarkBg ? 'bg-white/20' : 'bg-teal-50 group-hover:bg-teal-100'} transition-colors`}>
                                            {service.icon}
                                        </div>
                                        {/* Text Content */}
                                        <div>
                                            <h3 className={`font-bold text-sm tracking-wide ${isDarkBg ? 'text-white' : 'text-slate-800'}`}>
                                                {service.title} {service.subtitle && <span className="text-xs font-normal opacity-80">{service.subtitle}</span>}
                                            </h3>
                                            <p className={`text-xs mt-0.5 ${isDarkBg ? 'text-slate-200' : 'text-slate-500'}`}>
                                                {service.isLink ? (
                                                    <span className="text-teal-600 underline font-medium hover:text-teal-700">{service.description}</span>
                                                ) : (
                                                    service.description
                                                )}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Right Interactive Button */}
                                    {!service.isLink && (
                                        <button className={`p-1.5 rounded-full transition-transform group-hover:scale-110 ${isDarkBg
                                            ? 'bg-white/20 text-white hover:bg-white/30'
                                            : 'bg-teal-600 text-white hover:bg-teal-700'
                                            }`}>
                                            {isDarkBg ? <ChevronRight className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                                        </button>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Bottom Home Indicator Bar (Simulating Mobile Viewport) */}
                <div className="w-32 h-1 bg-slate-300 rounded-full mx-auto mt-4"></div>
            </div>

            // <div className="container">

            //     <h1>Customer Orders</h1>
            //     <div style={{ paddingTop: "10px", fontSize: "15px" }}>
            //         <FormGroup>
            //             <FaSearch size={20} style={{ position: "absolute", marginLeft: "90%", marginTop: "10px" }} />
            //             <Input
            //                 type='text'
            //                 id='searchOrders'
            //                 placeholder='Search by Phone number or Order ID'
            //                 onChange={this.setSearchTerm}
            //                 onKeyDown={this.clearSearchTerm}
            //             />
            //         </FormGroup>
            //     </div>
            //     <Ordertable data={this.state.allCustomerOrders}
            //         laststatus={this.getLastOrderStatus}
            //         navigation={(orderid) => this.props.navigate('/orderdetails', {
            //             state: {
            //                 orderid: orderid, fullname: this.state.fullname, emailaddress: this.state.emailaddress,
            //                 userid: this.state.userid, phonenumber: this.state.phonenumber, role: this.state.role, address:
            //                     this.state.address, area: this.state.area, city: this.state.city, page: this.state.page
            //             }

            //         })} />

            //     <div style={{ marginTop: "20px" }}>
            //         <FormGroup>
            //             <Label style={{ color: "#666", fontStyle: "italic" }} for='clothingweights'>Select weight</Label>
            //             <Select
            //                 options={this.state.foldlist || []}
            //                 maxMenuHeight="100%"
            //                 defaultInputValue=""
            //                 onChange={opt => this.setClothingWeightsChange(opt.label)}

            //             ></Select>
            //         </FormGroup>

            //     </div>

            // </div>
        );
    }
}
/////////


//////
export default withNavigateHook(Uat);
